module.exports = __webpack_public_path__ + "static/media/social.0974a759.jpg";